import React, { useEffect, useState } from "react";
import Select from "react-select";
import { url_ws } from "../../utils/Datos";
async function cargar() {
  //const url_produccion = "https://gateway.penalolen.cl:9443/";
  //const url_produccion = "https://gateway-vecinos.penalolen.cl:9443/";
  console.log('start funcionarios');
  const url_contract = "/officers/contract";
  const url_permanent = "/officers/permanent";

  if (localStorage.getItem(url_contract + url_permanent) != null) {
    //console.log('funcionarios en storage',localStorage.getItem(url_contract + url_permanent));
    return JSON.parse(localStorage.getItem(url_contract + url_permanent));
  }

  const fetchReq1 = await fetch(url_ws() + url_contract).then((res) =>
    res.json()
  );
  const fetchReq2 = await fetch(url_ws() + url_permanent).then((res) =>
    res.json()
  );

  const allData = Promise.all([fetchReq1, fetchReq2]);

  const opciones = await allData.then((res) => {
    let arr = res[0].concat(res[1]);
    //let ordenados=arr.sort((a,b)=>
    //  a.officerName.localCompare(b.officerName));

    //console.log('ordenados',ordenados);

    const opciones2 = arr.map((d, index) => {
      if (index === 0) {
        return {
          value: "",
          label: "Seleccione una opción",
        };
      } else {
        return {
          value: d.id_officer,
          label: d.officerName + " [" + d.typeOfContract + "]",
        };
      }
    });
    return opciones2;
  });
  localStorage.setItem(url_contract + url_permanent, JSON.stringify(opciones));
  return opciones;
}

export const Funcionarios = ({
  updateValue,
  nuevoValue,
  nombreCampo = "funcionarios",
  disabled,
}) => {
  const [actualizarProceso, setActualizarProceso] = useState(true);
  const [datos, setDatos] = useState(null);
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const [error, setError] = useState("");
  const [funcionarios, setFuncionarios] = useState(null);

  /*
  useEffect(() => {
    if (actualizarProceso && cargandoDatos === false) {
      setCargandoDatos(true);
      setActualizarProceso(false);
      cargar().then((opciones) => {
        setCargandoDatos(false);
        setFuncionarios(opciones[0]);
        setDatos(opciones);
        if (nuevoValue != null && nuevoValue != funcionarios.value) {
          const opcion = datos.find((d) => d.value == nuevoValue);
          if (opcion != null) {
            setFuncionarios(opcion);
          } else {
            updateValue(nombreCampo, opciones[0]);
          }
        } else {
          updateValue(nombreCampo, opciones[0]);
        }
      });
    }
  }, []);*/

  useEffect(() => {
    if (actualizarProceso && cargandoDatos === false) {
      setCargandoDatos(true);
      setActualizarProceso(false);
     
      cargar().then((opciones) => {
        setCargandoDatos(false);
        setFuncionarios(opciones[0]);
       
        setDatos(opciones);
        if (
          nuevoValue != null &&
          funcionarios != null &&
          nuevoValue != funcionarios.value
        ) {
          const opcion = datos.find((d) => d.value == nuevoValue);
          if (opcion != null) {
            setFuncionarios(opcion);
          } else {
            updateValue("funcionarios", opciones[0].value);
          }
        } else {
          updateValue("funcionarios", opciones[0].value);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (datos != null && nuevoValue != null) {
      const opcion = datos.find((d) => d.value == nuevoValue);
      if (opcion != null) {
        setFuncionarios(opcion);
      }
    }
  }, [nuevoValue]);

  return (
    <Select
      isDisabled={disabled}
      value={funcionarios}
      name={nombreCampo}
      onChange={(choice) => {
        updateValue(nombreCampo, choice.value);
        setFuncionarios(choice);
      }}
      placeholder="Seleccione"
      options={
        actualizarProceso || cargandoDatos
          ? [{ value: "", label: "Cargando datos..." }]
          : datos
      }
    />
  );
};
